import React, { Fragment } from "react";
import Translate from "./Translate"
export default function TranslateDescription({ input, lang }) {
    return (
        <Fragment>
            {input.split('<br>').map(function (item, key) {
                return (
                    <span key={key}>
                        <Translate input={item} lang={lang} />
                        <br />
                    </span>
                )
            })}
        </Fragment>)
}